var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card-actions',[_c('v-spacer'),_c('c-btn',{attrs:{"disabled":_vm.disableNext},on:{"click":_vm.$listeners.next}},[_vm._v(" "+_vm._s(_vm.$t('actions.next'))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }